import React from 'react'
import { BaseView } from '@/components/base'
import {
  ForgotPasswordEnterVerificationCodeForm,
  ForgotPasswordEnterVerificationCodeHeader,
  // ForgotPasswordResendVerificationCodeBtn,
} from '@/features/auth/forgot-password-enter-verification-code/components'

export const ForgotPasswordVerificationCodeScreen: React.FC = () => {
  return (
    <BaseView gap={24} className="h-full" flex={1}>
      <BaseView flex={1} gap={28}>
        <ForgotPasswordEnterVerificationCodeHeader />

        <ForgotPasswordEnterVerificationCodeForm />
        {/* moved button to form */}
        {/* <ForgotPasswordResendVerificationCodeBtn /> */}
      </BaseView>
    </BaseView>
  )
}
